export function fitText(element) {
  // Store original font size if not already stored
  if (!element.dataset.originalFontSize) {
    element.dataset.originalFontSize = window.getComputedStyle(element).fontSize;
  }
  
  // Reset to original size
  element.style.fontSize = element.dataset.originalFontSize;
  
  let fontSize = parseFloat(window.getComputedStyle(element).fontSize);
  const minFontSize = 10;
  const tolerance = 2;
  
  let iterations = 0;
  // Only check WIDTH overflow, let height expand naturally
  while (element.scrollWidth > element.clientWidth + tolerance && 
         fontSize > minFontSize) {
    fontSize -= 0.5;
    element.style.fontSize = fontSize + 'px';
    iterations++;
    
    if (iterations > 100) {
      console.error('Too many iterations, breaking loop');
      break;
    }
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  const textElements = document.querySelectorAll('.js-test-level-name');
  
  // Initial fit
  textElements.forEach(element => {
    fitText(element);
  });
  
  // Re-fit on window resize with debounce
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      textElements.forEach(element => {
        fitText(element);
      });
    }, 100); // Reduced from 250ms for faster response
  });
});